import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import ErrorBoundary from 'view/error-boundary/error-boundary';
import { token } from '@atlaskit/tokens';
import { ForgeUIExtensionAnalyticsContext } from '@atlassian/forge-ui';

import type { Extension } from '../types';

interface Props {
    extension: Extension;
    noWrapper?: boolean;
}

const errorBoundaryId = 'jsm-forge-extension-provider';

const ExtensionProviderContainerWrapper: React.FC<React.PropsWithChildren<{ noWrapper?: boolean }>> = ({
    noWrapper,
    children,
}) => (noWrapper ? <>{children}</> : <ExtensionProviderContainer>{children}</ExtensionProviderContainer>);

export const ExtensionProvider: React.FC<React.PropsWithChildren<Props>> = ({ children, extension, noWrapper }) => (
    <ErrorBoundary id={`${errorBoundaryId}-${extension.id}`} packageName={extension.type}>
        <ExtensionProviderContainerWrapper noWrapper={noWrapper}>
            <ForgeUIExtensionAnalyticsContext extensionId={extension.id} localId={extension.id}>
                {children}
            </ForgeUIExtensionAnalyticsContext>
        </ExtensionProviderContainerWrapper>
    </ErrorBoundary>
);

export default ExtensionProvider;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ExtensionProviderContainer = styled.div`
    margin-top: ${token('space.100', '8px')};
`;
